import { dxtToLocalServerTime } from "@dexteel/mesf-core";
import type { ColDef, ICellRendererParams } from "ag-grid-enterprise";
import moment from "moment";
import { CategoryTag } from "../components/CategoryTag";
import { GridButtons } from "../components/GridButtons";

const cellStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

type Props = {
  justifyData: Function;
  deleteData: Function;
  showContextMenu: Function;
};

export const useTableData = ({
  justifyData,
  deleteData,
  showContextMenu,
}: Props) => {
  const columnDefs: ColDef[] = [
    {
      field: "Start",
      headerName: "Start",
      valueGetter: (params) =>
        dxtToLocalServerTime(params.data?.Start, "HH:mm:ss") || "",
      maxWidth: 120,
      flex: 1,
      cellStyle: cellStyle,
    },
    {
      field: "End",
      headerName: "End",
      valueGetter: (params) =>
        dxtToLocalServerTime(params.data?.End, "HH:mm:ss") || "",
      maxWidth: 120,
      flex: 1,
      cellStyle: cellStyle,
    },
    {
      field: "Duration",
      headerName: "Duration",
      valueFormatter: (params) => {
        if (params.value) {
          const duration = moment.duration(params.value, "seconds");
          const minutes = Math.floor(duration.asMinutes());
          const seconds = duration.seconds();
          return `${minutes}m ${seconds}s`;
        }
        return "";
      },
      maxWidth: 120,
      flex: 1,
      cellStyle: cellStyle,
    },
    {
      field: "DelayCategory",
      headerName: "Category",
      valueGetter: (params) => {
        const delayCategoryName = params.data?.DelayCategoryName;
        const delayCategoryColor = params.data?.DelayCategoryColor;
        return { name: delayCategoryName, color: delayCategoryColor };
      },
      cellRenderer: CategoryTag,
      maxWidth: 120,
      editable: false,
      flex: 1,
      cellStyle: cellStyle,
    },
    {
      field: "DelayCodeName",
      headerName: "Code",
      maxWidth: 200,
      editable: false,
      flex: 1,
      cellStyle: cellStyle,
    },
    {
      field: "Comments",
      headerName: "Comments",
      flex: 1,
      cellStyle: cellStyle,
    },
    {
      field: "JustifiedByUser",
      headerName: "User",
      maxWidth: 150,
      editable: false,
      flex: 1,
      cellStyle: cellStyle,
    },
    {
      field: "JustifiedDatetime",
      headerName: "Justification Date",
      valueGetter: (params) =>
        dxtToLocalServerTime(params.data?.JustifiedDatetime, "MM-dd HH:mm"),
      maxWidth: 150,
      flex: 1,
      cellStyle: cellStyle,
    },
    {
      cellRenderer: GridButtons,
      cellRendererParams: (params: ICellRendererParams) => {
        return {
          params: params,
          justifyData: justifyData,
          deleteData: deleteData,
          showContextMenu: () =>
            showContextMenu(event, params.data, "delayManagerContext"),
        };
      },
      wrapText: false,
      wrapHeaderText: false,
      headerName: "",
      sortable: false,
      flex: 1,
      maxWidth: 150,
      minWidth: 150,
      filter: false,
      cellStyle: cellStyle,
    },
  ];
  return { columnDefs };
};
